import Vue from 'vue';
import SkyAccordion from './sky-accordion';

// Main component
Vue.component('sky-accordion', SkyAccordion);

export default SkyAccordion;



// WEBPACK FOOTER //
// ./scripts/sky-accordion/index.js